<template>
  <v-card outlined rounded="lg">
    <v-alert v-if="error" type="error" class="mb-0">{{ error }}</v-alert>
    <v-card-text class="d-flex flex-wrap justify-space-around px-">
      <div class="text-center d-flex flex-column align-center px-4">
        <v-skeleton-loader
          v-if="loading"
          width="50"
          height="20"
          class="mb-1"
          type="card"
        />
        <h6 v-else class="mb-0">
          {{ highlights.totalToday | number }}
          <evolution-display
            :actual="highlights.totalToday"
            :comparison="highlights.totalYesterday"
          />
        </h6>
        <span class="text-caption">Cadastros Hoje</span>
      </div>
      <div class="text-center d-flex flex-column align-center px-4">
        <v-skeleton-loader
          v-if="loading"
          width="50"
          height="20"
          class="mb-1"
          type="card"
        />
        <h6 v-else class="mb-0">
          {{ highlights.totalLastWeek | number }}
          <evolution-display
            :actual="highlights.totalLastWeek"
            :comparison="highlights.totalWeekBeforeLast"
          />
        </h6>
        <span class="text-caption">Cadastros essa Semana</span>
      </div>
      <div class="text-center d-flex flex-column align-center px-4">
        <v-skeleton-loader
          v-if="loading"
          width="50"
          height="20"
          class="mb-1"
          type="card"
        />
        <h6 v-else class="mb-0">
          {{ highlights.totalUsers | number }}
        </h6>
        <span class="text-caption">Total Usuários</span>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import USERS from "@/services/ultimate/users";
import EvolutionDisplay from "../../global/EvolutionDisplay.vue";

export default {
  components: { EvolutionDisplay },
  data() {
    return {
      highlights: null,
      loading: false,
      error: null,
    };
  },
  methods: {
    async getHighlights() {
      this.loading = true;
      try {
        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const response = await USERS.getUsersHighlight({ timezone });
        this.highlights = response;
      } catch (error) {
        this.error = error;
      } finally {
        this.loading = false;
      }
    },
  },
  created() {
    this.getHighlights();
  },
};
</script>

<style>
</style>